import type { Opts } from 'linkifyjs';

export const LinkifyOptions: Opts = {
  attributes: {
    title: 'External Link',
  },
  className: 'underline text-blue-200 hover:text-blue-400 visited:text-purple-100 whitespace-pre-line',
  defaultProtocol: 'https',
  target: '_blank',
  rel: 'noopener',
};
